/*
RecipeFooter.js
Adam Berger
July 2023
*/

import React from "react";
import eye from "assets/icons/Eye.svg";
import link from "assets/icons/hyperlink.svg";
import PropTypes from "prop-types";

export default function RecipeFooter({
  sourceUrl,
  tse,
  vc,
  userOwnsThisRecipe,
  isLoggedIn,
  ownerNickname,
}) {
  function domainFromUrl(url) {
    try {
      let domain = new URL(url).origin;
      return domain;
    } catch (error) {
      return "";
    }
  }

  function tseToDate(timestamp) {
    const timestampMs = Math.round(parseFloat(timestamp));
    if (isNaN(timestampMs)) return ""; // handle invalid timestamp
    const dateObj = new Date(timestampMs);
    const lastModified = dateObj.toDateString() + " at " + dateObj.toLocaleTimeString();
    return "Last modified "+ lastModified
  }

  const lastModifiedDate = tse ? tseToDate(tse) : "";

  return (
    <div className="detail-footer">
      <div className="detail-footer-recipe-info">
        {sourceUrl && (
          <div className="detail-recipe-source">
            Recipe source:{" "}
            <span className="detail-recipe-source-link">
              <a target="_blank" rel="noreferrer" href={sourceUrl}>
                <img src={link} />
                {domainFromUrl(sourceUrl)}
              </a>
            </span>
          </div>
        )}
        {isLoggedIn && userOwnsThisRecipe !== undefined && (
          <div className="detail-footer-ownership">
            {userOwnsThisRecipe
              ? 'You created this recipe.'
              : ownerNickname
                ? `Recipe uploaded by ${ownerNickname}.`
                : 'Another Kasserole user created this recipe.'}
          </div>
        )}
        <div className="detail-footer-container">
          {vc && (
            <div className="detail-footer-group">
              <img className="detail-footer-calendar" src={eye} />
              {vc}
            </div>
          )}
          {lastModifiedDate && (
            <div className="detail-footer-group">
              {lastModifiedDate}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

RecipeFooter.propTypes = {
  sourceUrl: PropTypes.string,
  vc: PropTypes.string,
  tse: PropTypes.string,
  userOwnsThisRecipe: PropTypes.bool,
  isLoggedIn: PropTypes.bool,
  ownerNickname: PropTypes.string,
};

RecipeFooter.defaultProps = {
  sourceUrl: "",
  vc: "",
  tse: "",
  userOwnsThisRecipe: false,
  isLoggedIn: false,
  ownerNickname: "",
};
